// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dj0-","questions":"styles_questions__2liDs","footer":"styles_footer__1Z4R7"};